module.exports = __webpack_public_path__ + "img/robot.12448d10.gif";